import {fabric} from 'fabric';
import {useCallback, useContext, useEffect, useState} from 'react';
import {UploadButton} from '~/CreateFabricGreetingCard/components/UploadButton/UploadButton';
import {DeleteButton} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/DeleteButton';
import {DoneButton} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/DoneButton';
import {ImageSize} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/ImageSize';
import {UyoImageRotate} from '~/CreateFabricGreetingCard/routes/CardCreateDesign/components/UyoImageRotate';
import {ContentBase} from '~/common/fabric/CreateDesign/components/CardEditor/Mobile/Contents/ContentBase';
import {menuMappingKeys} from '~/common/fabric/CreateDesign/constants';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

import './UyoEditor.sass';

export const UyoEditor = ({scrollToTop, setShowMenu, showMenu, activeMenu, setActiveMenu}) => {
  const [uyoImage, setUyoImage] = useState(null);
  const {canvas, activeObjects} = useContext(FabricContext);
  const isUyoSelected = activeObjects?.[0]?.type === 'uYOImage';
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);

  const onCloseUyoHandler = useCallback(() => {
    scrollToTop();
    setShowMenu(false);
    canvas.discardActiveObject();
    canvas.renderAll();
  }, [canvas, scrollToTop, setShowMenu]);

  const onResetClick = useCallback(
    (currElement) => {
      const scale = fabric.util.findScaleToCover(currElement, currElement._originalObject);

      const {left, top, angle} = currElement._originalObject;
      activeObjects[0].scale(scale).set({left, top, angle});
      canvas.renderAll();
    },
    [canvas, activeObjects[0].scale]
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (!showMenu && isUyoSelected) {
      setShowMenu(true);
      setActiveMenu(menuMappingKeys.UYO);
    }
  }, [activeMenu, activeObjects, showMenu]);

  useEffect(() => {
    if (activeObjects?.[0]?.type === 'uYOImage') {
      const [activeImage] = activeObjects;
      setUyoImage(activeImage);
    }
  }, [activeObjects]);

  if (isDesktop || !isUyoSelected) {
    return null;
  }

  return (
    <ContentBase
      resetDataQaId="edit-image-reset"
      closeDataQaId="edit-image-close"
      title="Photo Editor"
      onCloseClick={onCloseUyoHandler}
      visible={activeMenu === menuMappingKeys.UYO}
      onResetClick={onResetClick}
      className="content-base--uyo"
      uyoControls
      uyoImage={uyoImage}
    >
      <div className="uyo-control__edit-actions">
        <ImageSize />
        <UyoImageRotate btnText="Rotate" />
      </div>
      <div className="uyo-control__remove-actions">
        <UploadButton btnText="Upload New" isInPhotoEditor />
        <DeleteButton btnText="Remove Current" />
        <DoneButton handleDoneClick={onCloseUyoHandler} />
      </div>
    </ContentBase>
  );
};
